// utils/translations.js
const translations = {
    fr: {
        loadingQuestions: "Pour vous assurer la meilleure expérience, le jeu est en cours de maintenance. Veuillez revenir plus tard.",//
        pleaseSelectAnAnswer: "Veuillez sélectionner une réponse.",//
        correctAnswer: "Bonne réponse !",//
        tryAgain: "Essaie encore...",//
        questionLabel: "Question",//
        yourAnswer: "Votre réponse",//
        validateAnswer: "Valider ma réponse",//
        finishGame: "Terminer",//
        nextQuestion: "Question Suivante",//
        retry: "Réessayer",//
        hintFoundMessage: "Bravo, vous avez découvert un indice ! Notez-le précieusement, il vous aidera à découvrir l'énigme finale !",//
        closeButton: "Fermer",//
        backToHome: "Retour à l'accueil",
    },
    en: {
        loadingQuestions: "To ensure you the best experience, the game is undergoing maintenance. Please come back later.",
        pleaseSelectAnAnswer: "Please select an answer.",
        correctAnswer: "Correct answer!",
        tryAgain: "Try again...",
        questionLabel: "Question",
        yourAnswer: "Your answer",
        validateAnswer: "Validate my answer",
        finishGame: "Finish",
        nextQuestion: "Next question",
        retry: "Retry",
        hintFoundMessage: "Congratulations, you have found a clue! Write it down carefully, it will help you solve the final puzzle!",
        closeButton: "Close",
        backToHome: "Back to home"
    },
    de: {
        loadingQuestions: "Um Ihnen das beste Erlebnis zu bieten, wird das Spiel gerade gewartet. Bitte kommen Sie später wieder.",
        pleaseSelectAnAnswer: "Bitte wählen Sie eine Antwort aus.",
        correctAnswer: "Richtige Antwort!",
        tryAgain: "Versuche es noch einmal...",
        questionLabel: "Frage",
        yourAnswer: "Ihre Antwort",
        validateAnswer: "Antwort bestätigen",
        finishGame: "Beenden",
        nextQuestion: "Nächste Frage",
        retry: "Erneut versuchen",
        hintFoundMessage: "Glückwunsch, Sie haben einen Hinweis gefunden! Notieren Sie ihn sich gut, er wird Ihnen helfen, das letzte Rätsel zu lösen!",
        closeButton: "Schließen",
        backToHome: "Zur Startseite"
    },
    es: {
        loadingQuestions: "Para ofrecerle la mejor experiencia, el juego está en mantenimiento. Por favor, vuelva más tarde.",
        pleaseSelectAnAnswer: "Por favor, seleccione una respuesta.",
        correctAnswer: "¡Respuesta correcta!",
        tryAgain: "Inténtalo de nuevo...",
        questionLabel: "Pregunta",
        yourAnswer: "Tu respuesta",
        validateAnswer: "Validar mi respuesta",
        finishGame: "Finalizar",
        nextQuestion: "Siguiente pregunta",
        retry: "Reintentar",
        hintFoundMessage: "¡Felicidades, has encontrado una pista! Anótala cuidadosamente, te ayudará a resolver el enigma final!",
        closeButton: "Cerrar",
        backToHome: "Volver al inicio"
    },
    it: {
        loadingQuestions: "Per offrirti la migliore esperienza, il gioco è in manutenzione. Ti preghiamo di tornare più tardi.",
        pleaseSelectAnAnswer: "Seleziona una risposta, per favore.",
        correctAnswer: "Risposta corretta!",
        tryAgain: "Riprova...",
        questionLabel: "Domanda",
        yourAnswer: "La tua risposta",
        validateAnswer: "Conferma la mia risposta",
        finishGame: "Finisci",
        nextQuestion: "Prossima domanda",
        retry: "Riprova",
        hintFoundMessage: "Congratulazioni, hai trovato un indizio! Annotalo con attenzione, ti aiuterà a risolvere l'enigma finale!",
        closeButton: "Chiudi",
        backToHome: "Torna alla home"
    }
};

export default translations;
